<template>
  <v-card height="100%" class="pa-4" rounded="lg">
    <h2 style="font-size: 20px;">Online store conversion rate</h2>
    <h1 class="my-1">{{ conversionRate }}%</h1>
    <div class="d-flex align-center justify-space-between">
      <label class="border--text font-weight-medium">
        Online store
      </label>
      <h3>{{ onlineStoreConversionRate }}%</h3>
    </div>
    <div class="d-flex align-center justify-space-between mb-4">
      <label class="border--text">
        Boost Upsell conversion rate
      </label>
      <h3>{{ uselConversionRate }}%</h3>
    </div>
    <h3 class="font-weight-medium">CONVERSION FUNNEL</h3>
    <Bar v-if="!isLoading" :chartdata="chartData" :options="chartOptions" :height="300" />
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import Bar from '@/components/chart/Bar';
import { FETCH_CONVERSION_RATE } from '@/store/actions.type';
import STORAGE_NAME from '@/const/storage';

export default {
  props: {
    dateRange: {
      from: Date,
      to: Date,
    },
    stores: Array,
    timezone: String,
  },
  components: {
    Bar,
  },
  data() {
    return {
      isLoading: false,
      data: null,
    };
  },
  async created() {
    this.isLoading = true;
    let { startDate, endDate, stores } = this.loadQueryFromCache();
    let fromTime = startDate
      ? startDate
      : this.$props.dateRange && this.$props.dateRange.from
      ? moment(this.$props.dateRange.from).format('YYYY-MM-DD')
      : moment()
          .tz(this.timezone)
          .format('YYYY-MM-DD');
    let toTime = endDate
      ? endDate
      : this.$props.dateRange && this.$props.dateRange.to
      ? moment(this.$props.dateRange.to).format('YYYY-MM-DD')
      : moment()
          .tz(this.timezone)
          .format('YYYY-MM-DD');
    let _stores = stores ? stores : this.$props.stores ? this.$props.stores : '';
    await this.$store.dispatch(FETCH_CONVERSION_RATE, { fromTime, toTime, stores: _stores, timezone: this.timezone });
    this.isLoading = false;
  },
  methods: {
    loadQueryFromCache() {
      let cacheQuery = localStorage.getItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
      return cacheQuery ? JSON.parse(cacheQuery) : {};
    },
  },
  computed: {
    ...mapGetters(['chartData', 'chartOptions']),
    conversionRate() {
      return this.$store.getters.conversionRate;
    },
    uselConversionRate() {
      return this.$store.getters.uselConversionRate;
    },
    onlineStoreConversionRate() {
      return this.$store.getters.onlineStoreConversionRate;
    },
  },
  watch: {
    dateRange: async function(newTime, currTime) {
      // let { stores } = this.loadQueryFromCache();
      let fromTime = newTime
        ? moment(newTime.from).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      let toTime =
        newTime && newTime.to
          ? moment(newTime.to).format('YYYY-MM-DD')
          : moment()
              .tz(this.timezone)
              .format('YYYY-MM-DD');
      await this.$store.dispatch(FETCH_CONVERSION_RATE, {
        fromTime,
        toTime,
        stores: this.stores,
        timezone: this.timezone,
      });
    },
    stores: async function(newStores, currStores) {
      let { startDate, endDate } = this.loadQueryFromCache();
      let fromTime = startDate
        ? startDate
        : this.$props.dateRange && this.$props.dateRange.from
        ? moment(this.$props.dateRange.from).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      let toTime = endDate
        ? endDate
        : this.$props.dateRange && this.$props.dateRange.to
        ? moment(this.$props.dateRange.to).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      await this.$store.dispatch(FETCH_CONVERSION_RATE, {
        fromTime,
        toTime,
        stores: newStores,
        timezone: this.timezone,
      });
    },
  },
};
</script>
